export default function () {
  return /Android|webOs|iPhone|iPad|iPod|BlackBerry|PlayBook|Windows Phone|Opera Mini|RnUmmanu/i.test(navigator.userAgent)
    || /iPad|iPhod|Iphone|RnUmmanu/i.test(navigator.platform);
}

export const isBrowserSupported = () => {
  const userAgent = navigator.userAgent;
  const isMobile = /Mobile/.test(userAgent);
  const isTablet = /Tablet/.test(userAgent);

  switch (true) {
    case (/Chrome/.test(userAgent)):
      return true;
      // Chrome web/mobile/tablet
    case (/Edge/.test(userAgent)):
      return true;
      // Edge web/mobile/tablet
    case (/Safari/.test(userAgent) && (isMobile || isTablet)):
      return true;
      // Safari mobile/tablet
    case (/RnUmmanu/.test(userAgent)):
      return true;
      // Set value for ReactNative wrapper
    default:
      return false;
  }
};

export const isInStandaloneMode = () => window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;

export const isIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
